import PropTypes from "prop-types"
import React from "react"
import { Card, CardBody, Col } from "reactstrap"

const MiniCardss = props => {
  const { title, text, iconClass, color } = props
  return (
    <React.Fragment>
      <Col xl="4">
        <Card className="mini-stats-wid">
          <CardBody>
            <div className="d-flex">
              <div className="flex-grow-1">
                <p className="text-muted fw-medium mb-2">{title}</p>
                <h4 className="mb-0">{text}</h4>
              </div>
              <div className="mini-stat-icon avatar-sm align-self-center rounded-circle bg-primary">
                <span
                  className={`avatar-title ${
                    (color === "danger" && "bg-danger") ||
                    (color === "success" && "bg-success") ||
                    (color === "warning" && "bg-warning") ||
                    (color === "info" && "bg-info")
                  }`}
                >
                  <i className={"bx " + iconClass + " font-size-24"} />
                </span>
              </div>
            </div>
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  )
}

MiniCardss.propTypes = {
  iconClass: PropTypes.string,
  text: PropTypes.string,
  title: PropTypes.string,
}

export default MiniCardss
